module.exports = __webpack_public_path__ + "media/promo/hochland/images/hoch-2d71117f3bc20be4f7d26947c3259de4.png";